import React from 'react';
import { Header } from './common';
import { WhizzyLoader } from '../components';
import { Section } from '../global';
import { SELECTOR_WIDTH } from '../util/vars';
import classNames from 'classnames';

export type Props = {
  /**
   * Page title.
   */
  title?: string;
  /**
   * Prints an action at the center of the hear.
   */
  actionContent?: React.ReactNode;
  /**
   * Disables container.
   */
  disableContainer?: boolean;
  /**
   * Filters/settings at top.
   */
  settings?: React.ReactNode | null;
  /**
   * Displays loader.
   */
  isLoading?: boolean;
  /**
   * Applies PDF specific classes.
   */
  isBuildingPdf?: boolean;
  /**
   * Prevents PDF last page break.
   */
  isPdfLastPage?: boolean;
  /**
   * Content.
   */
  children: React.ReactNode;
  hideHeader?: boolean;
  hideMenu?: boolean;
  subHeader?: React.ReactNode | null;
  fullWidthContent?: boolean;
  sticky?: boolean;
  classId?: number;
};

const GlobalDashboardLayout = ({
  actionContent,
  title,
  disableContainer = false,
  settings,
  isLoading = false,
  isBuildingPdf,
  isPdfLastPage,
  children,
  hideHeader,
  hideMenu,
  subHeader = null,
  fullWidthContent = false,
  sticky = false,
  classId,
}: Props): JSX.Element => {

  return (
    <div className={`relative flex flex-col justify-between w-full ${!isBuildingPdf ? 'h-screen' : null}`}>
      <div>
        <div>
          { hideHeader ||
            <Header
              hideMenu={hideMenu}
              classId={classId}
            >
              <div
                className={'flex items-center justify-center mx-auto'}
                style={{
                  maxWidth: SELECTOR_WIDTH,
                }}
              >
                {actionContent ? actionContent : null}
              </div>
            </Header>
          }

          {title && (
            <div className={'flex items-center justify-center w-full mx-auto py-4 bg-white'} data-hide-print>
              <div className={'p-1 border-b-4 border-header'}>
                <b className={'text-xl md:text-2xl'}>{title}</b>
              </div>
            </div>
          )}

          {/* Roster Management submenu */}
          {subHeader}
        </div>
        {/* sticky interferes with PDF page breaks rendering */}
        <div className={'flex flex-col justify-center w-full'}>
          { (!isLoading && settings) ? (
            <div className={`${(!isBuildingPdf && sticky) && 'sticky z-30 top-0'} bg-light border-b border-gray-300`}>
              <div className={'max-w-screen-xl w-full mx-auto px-md'}>
                <div className={'py-4'} id='settings-container'>
                  {settings}
                </div>
              </div>
            </div>
          ) : null}
          <div className={`${classNames({ 'max-w-screen-xl': !fullWidthContent })} w-full mx-auto px-md`}>
            <div className={`${!isPdfLastPage && 'pdf-next-page'} ${!isBuildingPdf ? 'container' : 'mx-md'} mt-8 pt-0`}>
              <WhizzyLoader show={isLoading}/>
              {!isLoading ? (
                disableContainer ? children : (
                  <Section>
                    <div className={'container'}>
                      {children}
                    </div>
                  </Section>
                ))
                : null
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalDashboardLayout;
